import { Scene } from '../lib/apiClient';

const isAbsoluteUrl = (value?: string): value is string => !!value && /^https?:\/\//i.test(value);

/** Vue en lecture seule d'une scène : texte, image et lecteur audio. */
export default function SceneReview({ scene }: { scene: Scene }) {
  const imageUrl = scene.illustration?.asset_url;

  return (
    <article className="grid grid-cols-1 md:grid-cols-2 gap-6" aria-label={`Scène ${scene.scene_number}`}>
      <div className="space-y-3">
        <p className="text-xs font-bold text-amber-400">
          Scène {scene.scene_number} • {scene.phase} • {scene.estimated_duration_seconds}s
        </p>
        {scene.title && <h3 className="text-lg font-semibold text-slate-100">{scene.title}</h3>}
        <p className="text-sm text-slate-200 leading-relaxed whitespace-pre-line">{scene.text}</p>
        {isAbsoluteUrl(scene.audio_url) ? (
          <audio controls preload="none" src={scene.audio_url} className="w-full" aria-label="Audio de la scène" />
        ) : (
          <p role="status" className="text-xs text-amber-300">
            Audio indisponible pour cette scène.
          </p>
        )}
      </div>
      <div>
        {isAbsoluteUrl(imageUrl) ? (
          <img
            src={imageUrl}
            alt={scene.illustration?.prompt_fr ?? ''}
            className="w-full max-h-[420px] object-contain rounded-lg border border-slate-800"
          />
        ) : (
          <div
            role="status"
            className="flex h-48 items-center justify-center rounded-lg border border-dashed border-slate-700 text-xs text-slate-500"
          >
            Image indisponible
          </div>
        )}
        {scene.illustration?.prompt_fr && (
          <p className="mt-2 text-[11px] text-slate-500">Prompt : {scene.illustration.prompt_fr}</p>
        )}
      </div>
    </article>
  );
}
